import { createApp } from 'vue';
import { formatDateByLocale } from '../yfantis.js';

jQuery(function($) {
    if($("#YF-content-repertoire").length === 1) {
        createApp({
            data: () => ({
                repertoire: [],
                searchsongsfilterkey: '',
                chSong: { date_in_repertoire: '', songitems: [] },
                locale: '',
                linkresolver: '',
                wpnonce: '',
                wpbaseurl: '',
                fileIcons: [
                    'unknown',
                    'fa-link',          // weblink, video
                    'fa-link',          // weblink, pagina
                    'fa-file-o',        // generic document
                    'fa-file-pdf-o',
                    'fa-file-sound-o',  // musicnotationfile
                    'fa-file-audio-o',
                    'fa-file-image-o'

                ],
                columnOptions: [
                    {label: 'Archief nummer',   value: '1', dbfieldname: 'archive_number', sortable: true},
                    {label: 'Titel',            value: '2', dbfieldname: 'title', sortable: true},
                    {label: 'Componist',        value: '3', dbfieldname: 'composer', sortable: true},
                    {label: 'Tags',             value: '4', dbfieldname: 'tags', sortable: true},
                    {label: 'Docs',             value: '5', dbfieldname: 'docs', sortable: false},
                ],
                sortColumn: '1',
                sortOrder: 'asc'
            }),
            mounted() {
                console.log("Vue is ready..");
                this.getRepertoire();
                this.getLocale();
                this.getLinkresolver();
                this.getWPNonce();
                this.getWPBaseUrl();
            },
            methods: {
                formatDateByLocale,
                getRepertoire() {
                    this.repertoire = repertoireAsJson;
                },
                getLocale() {
                    this.locale = currentLocale;
                },
                getLinkresolver() {
                    this.linkresolver = linkresolver;
                    this.linkresolver = this.linkresolver.slice(-1) === '/' ? this.linkresolver : this.linkresolver + '/';
                },
                getWPNonce() {
                    this.wpnonce = wpnonce;
                },
                getWPBaseUrl() {
                    this.wpbaseurl = wpbaseurl;
                },
                chooseSong(index) {
                    this.chSong = this.filteredReperoire[index];
                },
                printlist: function() {
                    // use wordpress api endpoint to generate PDF.
                    // uses dompdf library. It will try to stream the output.
                    let columnString = '';
                    $("[name='cols[]']").each(function() {
                        if($(this).prop('checked')) {
                            columnString += $(this).val();
                        }
                    });
                    if(columnString !== '') {
                        let sortField = this.columnOptions.filter (
                            // explicit type needed
                            option => parseInt(option.value) === parseInt(this.sortColumn)
                        )[0].dbfieldname;
                        document.location.href = `${this.wpbaseurl}wp-json/yfantis/v1/listprinter?cols=${columnString}&sort=${sortField}&order=${this.sortOrder}&q=${this.searchsongsfilterkey}&_wpnonce=${this.wpnonce}`;
                    }
                }
            },
            computed: {
                filteredReperoire() {
                    if (!Array.isArray(this.repertoire)) {
                        return [];
                    }
                    return this.repertoire.filter(
                        song => {

                            song.title = song.title || '';
                            song.tags = song.tags || '';
                            song.archive_number = song.archive_number || '';

                            return (song.title.toLowerCase().includes(this.searchsongsfilterkey.toLowerCase()) ||
                                song.tags.toLowerCase().includes(this.searchsongsfilterkey.toLowerCase()) ||
                                song.archive_number.toLowerCase().includes(this.searchsongsfilterkey.toLowerCase()))
                        }
                    );
                }
            }
        }).mount('#YF-content-repertoire');
    }

    // Vue Teleport keeps body-level popups in the application's reactive tree.

    // center the modal on the screen
    function centerModal() {
        $(this).css('display', 'block');
        const $dialog  = $(this).find(".modal-dialog"),
            bottomMargin = parseInt($dialog.css('marginBottom'), 10);
        let offset       = ($(window).height() - $dialog.height()) / 2;
        // Make sure you don't hide the top part of the modal w/ a negative margin if it's longer than the screen height,
        // and keep the margin equal to the bottom margin of the modal
        if(offset < bottomMargin) offset = bottomMargin;
        $dialog.css("margin-top", offset);
    }

    $(document).on('show.bs.modal', '.modal', centerModal);
    $(window).on("resize", function () {
        $('.modal:visible').each(centerModal);
    });
});
